/**
 * 指挥页公告拉取
 */
import { shouldShowPublicAnnouncement } from './dashboardSettingsHelpers';
import { readResponseJsonSafe, isBackendUnavailableError } from './httpResponseHelpers';

/**
 * @returns {Promise<{ announcement: object|null, show: boolean }>}
 */
export async function fetchPublicAnnouncementState(options = {}) {
  const {
    fetchImpl = fetch,
    url = '/api/admin/announcements/public',
    getClosedId = () => {
      try {
        return localStorage.getItem('closed_announcement_id');
      } catch (_) {
        return null;
      }
    }
  } = options;

  try {
    const res = await fetchImpl(url);
    const parsed = await readResponseJsonSafe(res);
    if (!res.ok || !parsed.ok) {
      if (!isBackendUnavailableError(parsed.error, parsed.text) && process.env.NODE_ENV !== 'production') {
        console.warn('获取公告失败:', res.status, (parsed.text || '').slice(0, 120));
      }
      return { announcement: null, show: false };
    }
    const data = parsed.data || {};
    if (data.success && data.announcement) {
      const ann = data.announcement;
      const closedAnnId = getClosedId();
      if (shouldShowPublicAnnouncement(ann, closedAnnId)) {
        return { announcement: ann, show: true };
      }
      return { announcement: null, show: false };
    }
    return { announcement: null, show: false };
  } catch (error) {
    if (!isBackendUnavailableError(error) && process.env.NODE_ENV !== 'production') {
      console.warn('获取公告失败:', error);
    }
    return { announcement: null, show: false, error };
  }
}

export function closePublicAnnouncement(announcement) {
  if (!announcement) return;
  try {
    localStorage.setItem('closed_announcement_id', announcement.id.toString());
  } catch (_) {
    /* ignore */
  }
}
